module.exports = __webpack_public_path__ + "img/GetIt.4f5331c9.png";